module.exports = __webpack_public_path__ + "img/1.bf0f35b0.png";